export const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_BASE_URL || "http://127.0.0.1:8080/api";

export const BUILD_ENV = process.env.REACT_APP_BUILD_ENV || "dev";
